import React from 'react';

const Text = (props) => {
    return (
        <p className={`text ${props.className ? props.className : ''}`} style={!!props && !!props.style ? props.style : {}}>{props.children}</p>
    );
}

export default Text;
